/* unplugin-vue-components disabled */import __unplugin_components_0 from '~icons/mdi/whatsapp';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    _vm._b(
      {
        attrs: { dark: "", title: _vm.title },
        on: {
          click: function ($event) {
            return _vm.open()
          },
        },
      },
      "v-btn",
      _vm.$attrs,
      false
    ),
    [_c(__unplugin_components_0), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }